import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { getUserWalletTransactionRequest } from '../../utils/api';
import { FilterWrapper, TableWrapper } from '../UI/styledConstants';
import Pagination from '../Pagination/Pagination';
import { isEmpty, pdfData } from '../../utils/common';
import LocalLoader from '../UI/Loader/LocalLoader';
import { CSVLink } from 'react-csv';
import '../Login/UserProfile/style.css';
import { ServiceBoxWrapper } from '../ServicesBox/style';
import bbpsLogo2 from '../../assets/images/BBPS3.svg';
import Back from '../UIbox/Back';
import TransactionReceipt from './TransactionReceipt';

const WalletHistory = () => {
	const [downloadLoader, setDownloadLoader] = useState('');
	const [filter, setFilter] = useState({
		fromDate: '',
		toDate: '',
		txnType: null,
		serviceType: '',
		pageNo: 0,
		pageSize: 10,
		walletType: 'MAIN_WALLET',
	});

	const [loading, setLoading] = useState(null);

	const [walletHistory, setWalletHistory] = useState([]);
	const [history, setHistory] = useState({});
	const [paging_data, setPagingData] = useState(null);
	const [totalElement, setTotalElement] = useState('');
	const [csvData, setCsvData] = useState([]);

	const link = useRef(null);

	const getWalletHistory = async (key) => {
		let txnType = filter.txnType;
		let fromDate = '';
		let toDate = '';
		if (filter.txnType === '') {
			txnType = null;
		}

		if (!isEmpty(filter.fromDate)) {
			const parts = filter.fromDate.split('-');
			const formattedDate = parts[0] + '-' + parts[1] + '-' + parts[2];
			fromDate = formattedDate;
		}
		if (!isEmpty(filter.toDate)) {
			const parts = filter.toDate.split('-');
			const formattedDate = parts[0] + '-' + parts[1] + '-' + parts[2];
			toDate = formattedDate;
		}

		const param = {
			walletType: filter.walletType,
			fromDate: fromDate,
			toDate: toDate,
			txnType: txnType,
			serviceType: '',
			sortBy: '',
			pagination: {
				pageNo: filter.pageNo,
				pageSize: 10,
			},
		};
		if (key === 'csv' || key === 'pdf') {
			if (key === 'csv') {
				setDownloadLoader('csv');
			} else {
				setDownloadLoader('pdf');
			}
			param.pagination.pageSize = totalElement;
		} else {
			setLoading(true);
		}
		setLoading(true);
		getUserWalletTransactionRequest(param).then((resp) => {
			setLoading(false);
			setDownloadLoader('');
			if (resp?.success) {
				if (key !== 'csv' && key !== 'pdf') {
					setWalletHistory(resp?.data?.content);
					setTotalElement(resp?.data?.totalElements);
					setPagingData({
						number: resp?.data?.number,
						totalPages: resp?.data?.totalPages,
					});
				} else if (key === 'csv') {
					setCsvData(resp?.data?.content);

					const csvlink = link.current;
					csvlink.link.click();
				} else if (key === 'pdf') {
					setCsvData(resp?.data?.content);
					pdfDownload(resp?.data?.content);
				}
			} else {
				setWalletHistory([]);
			}
		});
	};

	const filterChangeHandler = (e) => {
		const { name, value } = e.target;
		if (name === 'toDate') {
			if (isEmpty(filter.fromDate)) {
				return false;
			}
		}
		setFilter({ ...filter, pageNo: 0, [name]: value });
	};

	useEffect(() => {
		getWalletHistory('');
	}, [filter.walletType, filter.pageNo, filter.txnType]);

	const pdfDownload = (data) => {
		const tableHeader = [
			{
				userId: 'User Id',
				Remark: 'Remark',
				transactionId: 'Transaction Id',
				createdDate: 'Date',
				openingAmount: 'Opening Amount',
				currentAmount: 'Closing Amount',
				charges: 'Service Charge',
				commission: 'Commission',
				gst: 'GST',
				transactionType: 'Transaction Type',
				txnStatus: 'Status',
				transactionAmout: 'Transaction Amount',
				finalTxnAmount: 'Final Transaction Amount',
			},
		];

		pdfData(data, tableHeader, 'History', 400);
	};

	return (
		<div className="container">
			<ServiceBoxWrapper className="bbps">
				<div className="header flex justify-between items-center">
					<Back url="/" />
					<h2 className="m0">Wallet History</h2>
					<div>{/* <img src={bbpsLogo2} alt="bbps logo" /> */}</div>
				</div>
				<div className="service-box-body">
					<div className=" flex">
						<div className="personal-information  transaction">
							<FilterWrapper className="flex items-center justify-between">
								<div className="filterBox">
									<div className="filter-text">Filter By</div>

									<div className="input-field">
										<select placeholder="Select WalletType" value={filter?.walletType} name="walletType" onChange={filterChangeHandler}>
											<option selected value={'MAIN_WALLET'}>
												Main Wallet
											</option>
											<option value={'AEPS_WALLET'}>AEPS Wallet</option>
										</select>
									</div>
									<div className="input-field">
										<select placeholder="Transaction Type" value={filter?.txnType} name="txnType" onChange={filterChangeHandler}>
											<option selected value={''}>
												Transaction Type
											</option>
											<option value={'CREDIT'}>CREDIT</option>
											<option value={'DEBIT'}>DEBIT</option>
										</select>
									</div>
									{/* <div className="input-field">
								<input type="text" placeholder="Mobile" />
							</div> */}
									<div
										className="input-field date-filter"
										// style={{ overflow: 'hidden' }}
									>
										<span style={{ fontWeight: '600', marginLeft: '8px' }}>From</span>
										<input
											type="date"
											placeholder="DD-MM-YYYY"
											name="fromDate"
											value={filter.fromDate}
											onChange={filterChangeHandler}
											onClick={(e) => e.currentTarget.showPicker()}
										/>
										<span style={{ fontWeight: '600' }}>To</span>
										<input
											type="date"
											placeholder="DD-MM-YYYY"
											name="toDate"
											value={filter.toDate}
											min={filter.fromDate}
											onChange={filterChangeHandler}
											disabled={isEmpty(filter.fromDate)}
											onClick={(e) => e.currentTarget.showPicker()}
										/>
									</div>
									<div className="input-field filter-Button flex gap-10">
										<button className="filterButton" onClick={() => getWalletHistory('')}>
											GO
										</button>
										{downloadLoader !== 'csv' ? (
											<button className="filterButton csv" onClick={() => getWalletHistory('csv')}>
												CSV
											</button>
										) : (
											<button className="filterButton btn-loader">
												<div className="btn-loader">
													<i className="fa-solid fa-spinner"></i>
												</div>
											</button>
										)}
										{downloadLoader !== 'pdf' ? (
											<button className="filterButton" onClick={() => getWalletHistory('pdf')}>
												PDF
											</button>
										) : (
											<button className="filterButton ">
												<div className="btn-loader">
													<i className="fa-solid fa-spinner"></i>
												</div>
											</button>
										)}
										<CSVLink ref={link} data={csvData} filename={'Transaction-History.csv'}></CSVLink>
									</div>
								</div>
							</FilterWrapper>
							<TableWrapper className="mt20 table-card-wrapper">
								{loading && <LocalLoader className="tableLoader" />}
								<table className="table">
									<thead className="table-head">
										<tr>
											<th>Sr. No</th>
											<th>User Id</th>
											<th className="text-right remark">Remark</th>
											<th>Transaction Id</th>
											<th>Date</th>
											<th>Opening Amount</th>
											<th className="text-right">Closing Amount</th>
											<th>Service Charge</th>
											<th>Commission</th>
											<th>GST</th>
											<th>Transaction Type</th>
											<th>Status</th>
											<th>Transaction Amount</th>
											<th className="text-right"> Final Transaction Amount</th>
											<th className="text-right">Receipt</th>
										</tr>
									</thead>
									<tbody className="table-body">
										{walletHistory &&
											walletHistory.map((data, i) => {
												const update = new Date(data.createdDate).toLocaleDateString('en-us', {
													day: 'numeric',
													month: 'short',
													year: 'numeric',
													hour: 'numeric',
													minute: 'numeric',
													second: 'numeric',
													hour12: true,
												});
												return (
													<tr key={i}>
														<td className="d-m-none">
															<span className="card-th">Sr No</span>
															<span>{filter.pageSize * filter.pageNo + (i + 1)}</span>
														</td>

														<td>
															<span className="card-th">User Id</span>
															<span>{data.userId || 'null'}</span>
														</td>
														<td className=" remark">
															<span className="card-th">Remark</span>
															<span>{data.remarks || 'null'}</span>
														</td>
														<td style={{ whiteSpace: 'normal' }}>
															<span className="card-th">Transaction Id</span>
															<span>{data.transactionId || 'null'}</span>
														</td>
														<td>
															<span className="card-th">Date</span>
															<span>{update}</span>
														</td>
														<td>
															<span className="card-th">Opening Amount</span>
															<span>₹ {data?.openingAmount?.toFixed(2) || 0}</span>
														</td>
														<td>
															<span className="card-th">Closing Amount</span>
															<span>₹ {data.currentAmount?.toFixed(2) || 0}</span>
														</td>
														<td>
															<span className="card-th">Service Charge</span>
															<span>₹ {data?.charges?.toFixed(2) || 0}</span>
														</td>
														<td>
															<span className="card-th">Commission</span>
															<span>₹ {data?.commission?.toFixed(2) || 0}</span>
														</td>
														<td>
															<span className="card-th">GST</span>
															<span>₹ {data?.gst?.toFixed(2) || 0}</span>
														</td>
														<td>
															<span className="card-th">Transaction Type</span>
															<span>{data.transactionType}</span>{' '}
														</td>
														<td>
															<span className="card-th">Status</span>
															<span style={(data?.txnStatus).toUpperCase() === 'SUCCESS' ? { color: 'green' } : { color: 'red' }}>{data?.txnStatus || null}</span>{' '}
														</td>
														<td>
															<span className="card-th">Transaction Amount</span>
															<span className={` ${data.transactionType == 'CREDIT' ? '' : ''}`}>₹ {data.transactionAmout?.toFixed(2) || 0}</span>
														</td>
														<td className={`text-right`}>
															<span className="card-th">Final Transaction Amount</span>
															<span>₹ {data.finalTxnAmount?.toFixed(2) || 0}</span>
														</td>
														<td>
															<span className="card-th">Receipt</span>
															<button className="viewButton" onClick={() => setHistory(data)}>
																<i class="fa-solid fa-eye"></i>
																<span>View</span>
															</button>
														</td>
													</tr>
												);
											})}

										{isEmpty(walletHistory) && !loading && (
											<tr>
												<td></td>
												<td></td>
												<td></td>
												<td></td>
												<td>NO record found</td>
												<td></td>
												<td></td>
												<td></td>
												<td></td>
											</tr>
										)}
									</tbody>
								</table>
							</TableWrapper>
							{paging_data && paging_data?.totalPages > 1 && (
								<Pagination currentPage={paging_data?.number} totalPages={paging_data?.totalPages} getCurrentPageData={(page) => setFilter({ ...filter, pageNo: page })} />
							)}
						</div>
					</div>
				</div>
				{!isEmpty(history) && <TransactionReceipt closePop={() => setHistory({})} transactionType={'Add Money'} bankDataResp={history} page="addmoney" />}
			</ServiceBoxWrapper>
		</div>
	);
};
export default WalletHistory;
